import { TAB_TRACKING_HOSTS } from "config/config";
import { trackTabHeartbeat, clearTabHeartbeatTag } from "utils/analytics";
import { startTabRegistry } from "./tab-registry";

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;

export function isTabTrackingEnabledForHost(): boolean {
  return (
    globalThis.window !== undefined &&
    TAB_TRACKING_HOSTS.includes(globalThis.window.location.hostname)
  );
}

// Starts presence tracking + a 5-min heartbeat. Only the leader tab emits, and a
// shared lastHeartbeatAt stamp dedupes the brief window where a leader handoff
// could leave two tabs both believing they lead. Returns a cleanup function.
export function installTabTracking(): () => void {
  if (!isTabTrackingEnabledForHost()) {
    return () => {};
  }

  const registry = startTabRegistry();

  const intervalId = setInterval(() => {
    if (!registry.isLeader()) {
      return;
    }
    const now = Date.now();
    if (now - registry.lastHeartbeatAt() < HEARTBEAT_INTERVAL_MS) {
      return;
    }
    registry.markHeartbeat(now);
    trackTabHeartbeat(registry.getTabCount());
  }, HEARTBEAT_INTERVAL_MS);

  return () => {
    clearInterval(intervalId);
    registry.stop();
    clearTabHeartbeatTag();
  };
}
